/**
 * Parse a number the user typed into a drawer input. Accepts German comma
 * decimals ("0,01") because that is how the operators write fractions.
 * Returns `null` for a blank or unparseable value so callers can tell
 * "no value" from a real `0` (which is a valid number).
 */
export const parseUserNumber = (
  raw: string | number | null | undefined,
): number | null => {
  if (raw === null || raw === undefined) return null;
  const trimmed = String(raw).trim();
  if (trimmed === "") return null;
  const parsed = Number(trimmed.replace(",", "."));
  return Number.isFinite(parsed) ? parsed : null;
};
